import styled, { css } from 'styled-components';
import { media } from '~constants/media';
import Button from '~components/Button';

export const ButtonsBlock = styled.div<{ desktopSmallView?: boolean }>`
  display: flex;
  margin-top: 30px;

  ${({ desktopSmallView }) => css`
    ${media.lg`
      margin-top: ${desktopSmallView ? '37px' : '47px'};
    `}
  `}
`;

const buttonCSS = css<{
  desktopSmallView?: boolean;
}>`
  display: inline-block;
  padding: 10px 15px;
  font-size: 10px;
  line-height: 12px;
  color: #fff !important; /* overriding styles from common.css, remove later */
  border: none;
  outline: none;
  border-radius: 5px;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  &:not(:first-child) {
    margin-left: 16px;
  }

  ${media.md`
    font-size: 14px;
    line-height: 16px;
  `}

  ${({ desktopSmallView }) => css`
    ${media.lg`
      ${
        desktopSmallView
          ? `padding: 12px 20px;`
          : `font-size: 16px;
           line-height: 18px;
           padding: 16px 28px;
          `
      }
      `}
  `}
`;

export const GreenButton = styled.button`
  ${buttonCSS};
  background-color: #7db828;
`;

export const BlueButton = styled.button`
  ${buttonCSS};
  background-color: #6078b9;
`;

export const BottomButtonWrapper = styled.div`
  margin-top: 14px;

  ${media.lg`
    margin-top: 20px;
  `}
`;

const bottomTextCss = css`
  font-size: 14px;
  line-height: 16px;
  color: #6078b9;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  ${media.lg`
    font-size: 16px;
    line-height: 18px;
  `}
`;

export const ObjectPageLink = styled.a`
  ${bottomTextCss};
  text-decoration: none;
`;

export const LearnDiscountsText = styled.span`
  ${bottomTextCss};
`;

export const DownloadPdfButton = styled(Button)`
  padding: 12px 18px;
  color: white;
  background-color: #6078b9;

  &:hover {
    opacity: 0.6;
  }
`;
